module.exports = __webpack_public_path__ + "img/Service1_Remanufacturing2.abfcd6c6.png";